'use client';

import { c as _c } from "react/compiler-runtime";
import { Dropdown, Grid, TextLink } from '@petsmart-ui/sparky';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { useEffect, useMemo, useRef } from 'react';
import { trackNavigationHeaderClick } from '@libs/analytics';
import { AccountDrawerType, getENV, useCart, useDecisions, useLogout, usePageLayout } from '@libs/common-next';
import { getPathnameFromPath, isLastActiveExpired, isRestrictedPathname, isUserLoggedIn, NAVIGATION_URLS } from '@libs/core';
import { handleAccountClick } from '@libs/experience-api';
import { useAccountDropdown } from '../../use-account-dropdown';
import './LoggedIn.scss';
const navigationUrls = NAVIGATION_URLS.velocity.account;
const navigationItems = [{
  label: 'About you',
  trackingKey: 'about you',
  url: navigationUrls.aboutYou
}, {
  label: 'Credit cards',
  trackingKey: 'payments',
  url: navigationUrls.creditCards
}, {
  label: 'Appointments',
  trackingKey: 'appointments',
  url: navigationUrls.servicesGrooming
}, {
  label: 'Autoship',
  trackingKey: 'autoship',
  url: navigationUrls.autoShip
}, {
  label: 'Recent orders',
  trackingKey: 'orders',
  url: navigationUrls.orderHistory
}, {
  label: 'Offers',
  trackingKey: 'offers',
  url: navigationUrls.offers
}];
export function LoggedIn() {
  const $ = _c(41);
  const {
    firstName,
    loyaltyPointsText
  } = useAccountDropdown();
  const {
    openAccountDrawer,
    setSignInDrawerProps
  } = usePageLayout();
  const {
    soft_login
  } = useDecisions();
  const {
    clearCart
  } = useCart();
  const logout = useLogout();
  const router = useRouter();
  const isLoyaltyAccountMenu = getENV("NEXT_PUBLIC_LOYALTY_ACCOUNT_MENU");
  const link = useRef("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames("legacy-loggedin", isLoyaltyAccountMenu ? "loyalty-account-menu-enabled" : "");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const wrapperClasses = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (globalThis.window !== undefined) {
        link.current = globalThis.location.origin;
      }
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== openAccountDrawer || $[4] !== router || $[5] !== setSignInDrawerProps || $[6] !== soft_login) {
    t3 = async event => {
      event.preventDefault();
      const link_0 = event.currentTarget.href;
      const rawLinkLabel = event.currentTarget.dataset.linkLabel ?? (event.currentTarget.innerText ?? event.currentTarget.textContent ?? "").trim();
      const linkLabel = rawLinkLabel && rawLinkLabel.length > 0 ? rawLinkLabel : "Account";
      const shouldOpenRestrictedLinkInSignInDrawer = soft_login && isUserLoggedIn() && isLastActiveExpired();
      if (shouldOpenRestrictedLinkInSignInDrawer && isRestrictedPathname(getPathnameFromPath(link_0))) {
        await handleAccountClick({
          event,
          link: link_0,
          skipNavigation: true,
          skipRedirect: true,
          router
        });
        if (isUserLoggedIn()) {
          return;
        }
        setSignInDrawerProps({
          redirectUrl: link_0,
          signInTitle: `${linkLabel} sign in`
        });
        openAccountDrawer(AccountDrawerType.SIGN_IN);
        return;
      }
      await handleAccountClick({
        event,
        link: link_0,
        router
      });
    };
    $[3] = openAccountDrawer;
    $[4] = router;
    $[5] = setSignInDrawerProps;
    $[6] = soft_login;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleLinkClick = t3;
  if (!firstName) {
    return null;
  }
  let t4;
  if ($[8] !== handleLinkClick) {
    t4 = async event_0 => {
      await handleLinkClick(event_0 as React.MouseEvent<HTMLAnchorElement>);
    };
    $[8] = handleLinkClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== firstName) {
    t5 = <span className="legacy-loggedin__greetings">Hi,{" "}<span className="legacy-loggedin__user-name" data-cs-mask={true}>{firstName}</span></span>;
    $[10] = firstName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="legacy-account__caret" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5) {
    t7 = <div className="legacy-loggedin__button"><TextLink href={navigationUrls.treatOffers} data-link-label={isLoyaltyAccountMenu ? "Treats Rewards" : "Account"} onClick={t4}>{t5}{t6}</TextLink></div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleLinkClick) {
    t8 = async event_1 => {
      await handleLinkClick(event_1);
    };
    $[16] = handleLinkClick;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = ` ${loyaltyPointsText} `;
  let t10;
  if ($[18] !== t9) {
    t10 = <span className="point-count" data-cs-mask={true}>{t9}</span>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="account">{isLoyaltyAccountMenu ? "Treats Rewards" : "Account"}</span>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <div className="points">{t10}{"pts. "}{t11}</div>;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t8) {
    t13 = <a className="points-link" href={navigationUrls.treatOffers} data-link-label={isLoyaltyAccountMenu ? "Treats Rewards" : "Account"} onClick={t8} title="Go to: View your rewards and offers">{t12}</a>;
    $[23] = t12;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== handleLinkClick) {
    t14 = navigationItems.map(item => <Grid.Item key={item.trackingKey}><TextLink href={item.url} data-link-label={item.label} onClick={async event_2 => {
        trackNavigationHeaderClick(item.trackingKey, link.current + item.url);
        handleLinkClick(event_2 as React.MouseEvent<HTMLAnchorElement>);
      }}>{item.label}</TextLink></Grid.Item>);
    $[26] = handleLinkClick;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <Grid variant="1-2up" gap="none">{t14}</Grid>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== clearCart || $[31] !== logout) {
    t16 = <TextLink className="logout-link" onClick={async () => await logout({
      redirectUrl: "/sign-in",
      forceRedirect: true,
      callback: clearCart
    })}>Logout</TextLink>;
    $[30] = clearCart;
    $[31] = logout;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t13 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className="legacy-loggedin__dropdown-wrapper"><Dropdown className="legacy-loggedin__dropdown"><div className="legacy-loggedin__submenu">{t13}{t15}{t16}</div></Dropdown></div>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="dropdown-accent" aria-hidden={true} />;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t7) {
    t19 = <div className={wrapperClasses} data-testid="logged-in">{t7}{t17}{t18}</div>;
    $[38] = t17;
    $[39] = t7;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
}